// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"50e6e3c3","977":"f3451c47"}[chunkId] + ".chunk.js";
};